module.exports = __webpack_public_path__ + "img/ar.3036121f.svg";